module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-footer-fixed-btn"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee8f9c82"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/baseComponents/ChooseButton.vue
// module id = 1093
// module chunks = 1